const key = 'projectIdForGLSSSO';

const save = (projectId: string) => {
  window.localStorage.setItem(key, projectId);
};

const get = () => {
  const projectId = window.localStorage.getItem(key);
  remove();

  return projectId;
};

const remove = () => {
  window.localStorage.removeItem(key);
};

export const ProjectIdForGLSSSO = { save, get };
